import * as Blockly from 'blockly/core';
import thresholdDefaultValueList from './indicator_content'

const createCustomThresholdFields = function (block) {
    block.validateCheckbox = validateCheckbox;
    block.updateThresholdDropdownField = updateThresholdDropdownField;
    block.validateThresholdDropdown = validateThresholdDropdown;
    block.updateThresholdNumberField = updateThresholdNumberField;
    block.validateIndicatorSelection = validateIndicatorSelection;
    block.updateDefaultThresholdDropdownField = updateDefaultThresholdDropdownField;
    block.updateDefaultThresholdNumberField = updateDefaultThresholdNumberField;
    block.updateDefaultThresholdUnitField = updateDefaultThresholdUnitField;

    // TODO get hold of the config value for GLOBE_DEBUG_MODE_AVAILABLE
    // and use it to conditionally create/show the threshold controls

    block.appendDummyInput("advancedOptions")
        .setAlign(Blockly.ALIGN_LEFT)
        .appendField("Advanced options")
        .appendField(new Blockly.FieldCheckbox(false, block.validateCheckbox), 'isCustomThreshold') 

    block.getField("indicator_selection").setValidator(block.validateIndicatorSelection);
}

const validateCheckbox = function (newValue) {
    let sourceBlock = this.getSourceBlock();
    sourceBlock.showThresholdDropdownField_ = newValue == 'TRUE';
    sourceBlock.updateThresholdDropdownField();
    return newValue;
}

const removeAdvancedOptions = function(block) {
    block.removeInput("thresholdControls")
    block.removeInput("debugControls")
}

const addAdvancedOptions = function(block) {
    block.appendDummyInput("thresholdControls")
        .setAlign(Blockly.ALIGN_LEFT) 

    block.appendDummyInput("debugControls")
        .setAlign(Blockly.ALIGN_LEFT)
}

const updateThresholdDropdownField = function(){

    let thresholdControls, debugControls;

    if (this.showThresholdDropdownField_ 
        && !this.getField("thresholdComparisontype") && !this.getField("thresholdText")
        && !this.getField("debugLayers") && !this.getField("debugLayersText")
        ){
        addAdvancedOptions(this);

        thresholdControls = this.getInput("thresholdControls");
        debugControls = this.getInput("debugControls");
        thresholdControls
            .appendField("   Set Threshold   ", "thresholdText")
            .appendField(new Blockly.FieldDropdown(
                [[">", "gt"],
                ["<", "lt"],
                ["≤", "lte"],
                ["≥", "gte"],
                ["No Threshold", "noThreshold"]],
                this.validateThresholdDropdown
            ), "thresholdComparisontype")
        
        // gets currently selected indicator, and its default dropdown values
        let chosenIndicator = this.getFieldValue("indicator_selection");
        let defaultThresholdDropdownValue = thresholdDefaultValueList[chosenIndicator].comparison;
        // sets default value - by product is that it also forces a call to validateThresholdDropdown
        let thresholdDropdown = this.getField("thresholdComparisontype")
        thresholdDropdown.setValue(defaultThresholdDropdownValue)

        debugControls
            .appendField("   Show intermediate layers   ", "debugLayersText")
            .appendField(new Blockly.FieldCheckbox(false), 'debugLayers')            

    } else if (!this.showThresholdDropdownField_ 
        && this.getField("thresholdComparisontype") && this.getField("thresholdText")
        && this.getField("debugLayers") && this.getField("debugLayersText")
        ){

        removeAdvancedOptions(this);

    }
}

const validateThresholdDropdown = function(newValue) {
    let sourceBlock = this.getSourceBlock();
    sourceBlock.showThresholdNumberField_ = newValue !== "noThreshold" && sourceBlock.showThresholdDropdownField_;
    sourceBlock.updateThresholdNumberField();
}

const updateThresholdNumberField = function() {
    let chosenIndicator = this.getFieldValue("indicator_selection");
    let defaultThresholdValue = thresholdDefaultValueList[chosenIndicator].default;
    let thresholdRange = thresholdDefaultValueList[chosenIndicator].range;
    let thresholdUnit = thresholdDefaultValueList[chosenIndicator].unit;
    let thresholdUnitDescription = thresholdDefaultValueList[chosenIndicator].unitDescription;
    let thresholdControls = this.getInput("thresholdControls");
    if (this.showThresholdNumberField_ && !this.getField("thresholdNumber")){
        thresholdControls
            .appendField(
                new Blockly.FieldNumber(
                    defaultThresholdValue, 
                    thresholdRange.min, 
                    thresholdRange.max
                ), 
                "thresholdNumber")
            .appendField(thresholdUnit, 'thresholdUnit')
        if (thresholdUnitDescription === '') {
            this.getField("thresholdNumber").setTooltip(thresholdUnit)
            this.getField("thresholdUnit").setTooltip(thresholdUnit)
        } else {
            this.getField("thresholdNumber").setTooltip(thresholdUnitDescription)
            this.getField("thresholdUnit").setTooltip(thresholdUnitDescription)
        }
        
    } else if (!this.showThresholdNumberField_ && this.getField("thresholdNumber")){
        thresholdControls.removeField("thresholdNumber");
        thresholdControls.removeField("thresholdUnit");
    }
}

const validateIndicatorSelection = function(newValue) {
    let block = this.getSourceBlock()

    if(block.showThresholdDropdownField_){
        block.updateDefaultThresholdDropdownField(newValue);
    }
    if(block.showThresholdNumberField_){
        block.updateDefaultThresholdNumberField(newValue);
        block.updateDefaultThresholdUnitField(newValue);
    }

    return newValue;
}

const updateDefaultThresholdDropdownField = function(newIndicator) {
    let thresholdDropdown = this.getField("thresholdComparisontype")
    if (thresholdDropdown) {
        let defaultThresholdDropdownValue = thresholdDefaultValueList[newIndicator].comparison;
        // sets default value - by product is that it also forces a call to validateThresholdDropdown
        thresholdDropdown.setValue(defaultThresholdDropdownValue)
    }
}

const updateDefaultThresholdNumberField = function(newIndicator) {
    let thresholdNumberField = this.getField("thresholdNumber");

    if (thresholdNumberField){
        let defaultThresholdValue = thresholdDefaultValueList[newIndicator].default;
        let thresholdRange = thresholdDefaultValueList[newIndicator].range;
        
        thresholdNumberField.setConstraints(thresholdRange.min, thresholdRange.max);
        thresholdNumberField.setValue(defaultThresholdValue);
    }
}

const updateDefaultThresholdUnitField = function(newIndicator) {
    let thresholdUnitField = this.getField("thresholdUnit");

    if (thresholdUnitField){
        let defaultThresholdUnit = thresholdDefaultValueList[newIndicator].unit;
        let defaultThresholdUnitDescription = thresholdDefaultValueList[newIndicator].unitDescription;
        
        if (defaultThresholdUnitDescription === '') {
            thresholdUnitField.setTooltip(defaultThresholdUnit);
        } else {
            thresholdUnitField.setTooltip(defaultThresholdUnitDescription);
        }
        
        thresholdUnitField.setValue(defaultThresholdUnit);
    }
}

export default createCustomThresholdFields